export const filters = {
    "dcs": [
        {
            "code": 4094,
            "desc": "4094 - Summerville, SC"
        },
        {
            "code": 4792,
            "desc": "4792 - Hattiesburg, MS"
        },
        {
            "code": 4889,
            "desc": "4889 - New Braunfels, TX"
        },
        {
            "code": 4964,
            "desc": "4964 - Jacksonville, FL"
        },
        {
            "code": 4965,
            "desc": "4965 - Oklahoma, OK"
        },
        {
            "code": 4966,
            "desc": "4966 - Edwardsville, IL"
        },
        {
            "code": 4968,
            "desc": "4968 - Shakopee, MN"
        },
        {
            "code": 6299,
            "desc": "6299 - Buckeye, AZ"
        },
        {
            "code": 6492,
            "desc": "6492 - North Canton, OH"
        },
        {
            "code": 6493,
            "desc": "6493 - Ontario, CA"
        },
        {
            "code": 6494,
            "desc": "6494 - Loveland, CO"
        },
        {
            "code": 6496,
            "desc": "6496 - Kansas City, KS"
        },
        {
            "code": 6499,
            "desc": "6499 - Villa Rica, GA"
        },
        {
            "code": 6596,
            "desc": "6596 - Brownstown, MI"
        },
        {
            "code": 6698,
            "desc": "6698 - Dayton, TX"
        },
        {
            "code": 7303,
            "desc": "7303 - Prince George, VA"
        },
        {
            "code": 7667,
            "desc": "7667 - Edgerton, KS"
        },
        {
            "code": 8206,
            "desc": "8206 - Charlotte, NC"
        },
        {
            "code": 8229,
            "desc": "8229 - Lakeland, FL"
        },
        {
            "code": 8231,
            "desc": "8231 - Taylor, PA"
        },
        {
            "code": 8232,
            "desc": "8232 - Greenfield, IN"
        },
        {
            "code": 8234,
            "desc": "8234 - Searcy, AR"
        },
        {
            "code": 8235,
            "desc": "8235 - Sanger, TX"
        },
        {
            "code": 8307,
            "desc": "8307 - Oswego, IL"
        }
    ],
    "clubs": [
        {
            "code": 4026,
            "desc": "4026 - Searcy, AR"
        },
        {
            "code": 4041,
            "desc": "4041 - Linden, NJ"
        },
        {
            "code": 4109,
            "desc": "4109 - Bossier City, LA"
        },
        {
            "code": 4702,
            "desc": "4702 - Friendswood, TX"
        },
        {
            "code": 4703,
            "desc": "4703 - Albuquerque, NM"
        },
        {
            "code": 4704,
            "desc": "4704 - Fresno, CA"
        },
        {
            "code": 4707,
            "desc": "4707 - Overland Park, KS"
        },
        {
            "code": 4709,
            "desc": "4709 - Corona, CA"
        },
        {
            "code": 4710,
            "desc": "4710 - Chesapeake, VA"
        },
        {
            "code": 4711,
            "desc": "4711 - Virginia Beach, VA"
        },
        {
            "code": 4712,
            "desc": "4712 - Houston, TX"
        },
        {
            "code": 4713,
            "desc": "4713 - Shenandoah, TX"
        },
        {
            "code": 4714,
            "desc": "4714 - Oklahoma City, OK"
        },
        {
            "code": 4718,
            "desc": "4718 - South Jordan, UT"
        },
        {
            "code": 4720,
            "desc": "4720 - Austin, TX"
        },
        {
            "code": 4721,
            "desc": "4721 - Houston, TX"
        },
        {
            "code": 4722,
            "desc": "4722 - Williamstown, NJ"
        },
        {
            "code": 4724,
            "desc": "4724 - Hoover, AL"
        },
        {
            "code": 4728,
            "desc": "4728 - Nicholasville, KY"
        },
        {
            "code": 4729,
            "desc": "4729 - Sterling, VA"
        },
        {
            "code": 4730,
            "desc": "4730 - West Jordan, UT"
        },
        {
            "code": 4731,
            "desc": "4731 - Oklahoma City, OK"
        },
        {
            "code": 4732,
            "desc": "4732 - Glendale, AZ"
        },
        {
            "code": 4735,
            "desc": "4735 - La Habra, CA"
        },
        {
            "code": 4736,
            "desc": "4736 - Apple Valley, MN"
        },
        {
            "code": 4738,
            "desc": "4738 - Eagan, MN"
        },
        {
            "code": 4739,
            "desc": "4739 - Snellville, GA"
        },
        {
            "code": 4740,
            "desc": "4740 - Southaven, MS"
        },
        {
            "code": 4741,
            "desc": "4741 - Saint Louis, MO"
        },
        {
            "code": 4742,
            "desc": "4742 - Fort Worth, TX"
        },
        {
            "code": 4743,
            "desc": "4743 - Plano, TX"
        },
        {
            "code": 4745,
            "desc": "4745 - Thornton, CO"
        },
        {
            "code": 4749,
            "desc": "4749 - Conway, AR"
        },
        {
            "code": 4750,
            "desc": "4750 - Cuyahoga Falls, OH"
        },
        {
            "code": 4761,
            "desc": "4761 - Norman, OK"
        },
        {
            "code": 4763,
            "desc": "4763 - Sugar Land, TX"
        },
        {
            "code": 4764,
            "desc": "4764 - Katy, TX"
        },
        {
            "code": 4767,
            "desc": "4767 - Palmdale, CA"
        },
        {
            "code": 4768,
            "desc": "4768 - Reno, NV"
        },
        {
            "code": 4769,
            "desc": "4769 - Houston, TX"
        },
        {
            "code": 4770,
            "desc": "4770 - Evans, CO"
        },
        {
            "code": 4771,
            "desc": "4771 - Severn, MD"
        },
        {
            "code": 4772,
            "desc": "4772 - Sarasota, FL"
        },
        {
            "code": 4774,
            "desc": "4774 - Secaucus, NJ"
        },
        {
            "code": 4775,
            "desc": "4775 - Metairie, LA"
        },
        {
            "code": 4776,
            "desc": "4776 - Huntsville, AL"
        },
        {
            "code": 4777,
            "desc": "4777 - Denver, CO"
        },
        {
            "code": 4778,
            "desc": "4778 - Auburn Hills, MI"
        },
        {
            "code": 4780,
            "desc": "4780 - Buford, GA"
        },
        {
            "code": 4781,
            "desc": "4781 - Lansing, MI"
        },
        {
            "code": 4782,
            "desc": "4782 - Kissimmee, FL"
        },
        {
            "code": 4783,
            "desc": "4783 - Garland, TX"
        },
        {
            "code": 4784,
            "desc": "4784 - Las Cruces, NM"
        },
        {
            "code": 4785,
            "desc": "4785 - Sanford, FL"
        },
        {
            "code": 4786,
            "desc": "4786 - Logan, UT"
        },
        {
            "code": 4787,
            "desc": "4787 - Bloomington, MN"
        },
        {
            "code": 4789,
            "desc": "4789 - Sharpsburg, GA"
        },
        {
            "code": 4790,
            "desc": "4790 - Pearl, MS"
        },
        {
            "code": 4791,
            "desc": "4791 - Garden City, KS"
        },
        {
            "code": 4794,
            "desc": "4794 - Lakeland, FL"
        },
        {
            "code": 4795,
            "desc": "4795 - Grapevine, TX"
        },
        {
            "code": 4797,
            "desc": "4797 - Kannapolis, NC"
        },
        {
            "code": 4798,
            "desc": "4798 - Winston Salem, NC"
        },
        {
            "code": 4799,
            "desc": "4799 - Citrus Heights, CA"
        },
        {
            "code": 4801,
            "desc": "4801 - Riverview, FL"
        },
        {
            "code": 4802,
            "desc": "4802 - Hiram, GA"
        },
        {
            "code": 4804,
            "desc": "4804 - Mcdonough, GA"
        },
        {
            "code": 4805,
            "desc": "4805 - Billings, MT"
        },
        {
            "code": 4808,
            "desc": "4808 - Springdale, AR"
        },
        {
            "code": 4813,
            "desc": "4813 - Memphis, TN"
        },
        {
            "code": 4815,
            "desc": "4815 - Normal, IL"
        },
        {
            "code": 4816,
            "desc": "4816 - Aurora, CO"
        },
        {
            "code": 4817,
            "desc": "4817 - Trussville, AL"
        },
        {
            "code": 4818,
            "desc": "4818 - Brooksville, FL"
        },
        {
            "code": 4819,
            "desc": "4819 - Bakersfield, CA"
        },
        {
            "code": 4820,
            "desc": "4820 - Pooler, GA"
        },
        {
            "code": 4822,
            "desc": "4822 - Murrieta, CA"
        },
        {
            "code": 4824,
            "desc": "4824 - Santa Clarita, CA"
        },
        {
            "code": 4825,
            "desc": "4825 - Hot Springs, AR"
        },
        {
            "code": 4828,
            "desc": "4828 - Orlando, FL"
        },
        {
            "code": 4829,
            "desc": "4829 - Gilbert, AZ"
        },
        {
            "code": 4830,
            "desc": "4830 - Avondale, AZ"
        },
        {
            "code": 4831,
            "desc": "4831 - Durham, NC"
        },
        {
            "code": 4836,
            "desc": "4836 - Oxford, AL"
        },
        {
            "code": 4837,
            "desc": "4837 - Denham Springs, LA"
        },
        {
            "code": 4839,
            "desc": "4839 - Tulsa, OK"
        },
        {
            "code": 4840,
            "desc": "4840 - Janesville, WI"
        },
        {
            "code": 4843,
            "desc": "4843 - Pearland, TX"
        },
        {
            "code": 4846,
            "desc": "4846 - Mentor, OH"
        },
        {
            "code": 4847,
            "desc": "4847 - Greensburg, PA"
        },
        {
            "code": 4850,
            "desc": "4850 - Mcallen, TX"
        },
        {
            "code": 4851,
            "desc": "4851 - Clarksville, IN"
        },
        {
            "code": 4852,
            "desc": "4852 - Wesley Chapel, FL"
        },
        {
            "code": 4853,
            "desc": "4853 - Castle Rock, CO"
        },
        {
            "code": 4855,
            "desc": "4855 - Hanover, PA"
        },
        {
            "code": 4857,
            "desc": "4857 - Cape Coral, FL"
        },
        {
            "code": 4859,
            "desc": "4859 - Butler, PA"
        },
        {
            "code": 4860,
            "desc": "4860 - Beckley, WV"
        },
        {
            "code": 4861,
            "desc": "4861 - St Petersburg, FL"
        },
        {
            "code": 4866,
            "desc": "4866 - San Juan, PR"
        },
        {
            "code": 4870,
            "desc": "4870 - Kansas City, KS"
        },
        {
            "code": 4871,
            "desc": "4871 - Meridian, MS"
        },
        {
            "code": 4872,
            "desc": "4872 - Columbia, SC"
        },
        {
            "code": 4873,
            "desc": "4873 - Lincoln, NE"
        },
        {
            "code": 4874,
            "desc": "4874 - Covington, LA"
        },
        {
            "code": 4875,
            "desc": "4875 - Wentzville, MO"
        },
        {
            "code": 4876,
            "desc": "4876 - Bowling Green, KY"
        },
        {
            "code": 4878,
            "desc": "4878 - Glen Carbon, IL"
        },
        {
            "code": 4879,
            "desc": "4879 - Aiken, SC"
        },
        {
            "code": 4901,
            "desc": "4901 - Easley, SC"
        },
        {
            "code": 4905,
            "desc": "4905 - Denton, TX"
        },
        {
            "code": 4906,
            "desc": "4906 - Mckinney, TX"
        },
        {
            "code": 4908,
            "desc": "4908 - Owensboro, KY"
        },
        {
            "code": 4911,
            "desc": "4911 - Mansfield, TX"
        },
        {
            "code": 4914,
            "desc": "4914 - San Antonio, TX"
        },
        {
            "code": 4915,
            "desc": "4915 - Bullhead City, AZ"
        },
        {
            "code": 4917,
            "desc": "4917 - Mooresville, NC"
        },
        {
            "code": 4920,
            "desc": "4920 - Saint Joseph, MO"
        },
        {
            "code": 4925,
            "desc": "4925 - Dallas, TX"
        },
        {
            "code": 4926,
            "desc": "4926 - Columbus, IN"
        },
        {
            "code": 4930,
            "desc": "4930 - Cookeville, TN"
        },
        {
            "code": 4933,
            "desc": "4933 - Bismarck, ND"
        },
        {
            "code": 4936,
            "desc": "4936 - Granville, WV"
        },
        {
            "code": 4937,
            "desc": "4937 - Shakopee, MN"
        },
        {
            "code": 4938,
            "desc": "4938 - Albuquerque, NM"
        },
        {
            "code": 4939,
            "desc": "4939 - San Antonio, TX"
        },
        {
            "code": 4942,
            "desc": "4942 - Elgin, IL"
        },
        {
            "code": 4944,
            "desc": "4944 - Grand Blanc, MI"
        },
        {
            "code": 4946,
            "desc": "4946 - Rocky Mount, NC"
        },
        {
            "code": 4947,
            "desc": "4947 - Zanesville, OH"
        },
        {
            "code": 4948,
            "desc": "4948 - San Angelo, TX"
        },
        {
            "code": 4950,
            "desc": "4950 - Hendersonville, NC"
        },
        {
            "code": 4951,
            "desc": "4951 - Edwardsville, IL"
        },
        {
            "code": 4952,
            "desc": "4952 - Tarentum, PA"
        },
        {
            "code": 4955,
            "desc": "4955 - Surprise, AZ"
        },
        {
            "code": 4958,
            "desc": "4958 - San Marcos, TX"
        },
        {
            "code": 4961,
            "desc": "4961 - Roswell, NM"
        },
        {
            "code": 4962,
            "desc": "4962 - Sandusky, OH"
        },
        {
            "code": 4963,
            "desc": "4963 - Chillicothe, OH"
        },
        {
            "code": 4969,
            "desc": "4969 - Bentonville, AR"
        },
        {
            "code": 4972,
            "desc": "4972 - Port St Lucie, FL"
        },
        {
            "code": 4973,
            "desc": "4973 - Dubuque, IA"
        },
        {
            "code": 4974,
            "desc": "4974 - North Las Vegas, NV"
        },
        {
            "code": 4982,
            "desc": "4982 - Mount Pleasant, MI"
        },
        {
            "code": 4983,
            "desc": "4983 - Las Vegas, NV"
        },
        {
            "code": 4985,
            "desc": "4985 - Springfield, MO"
        },
        {
            "code": 4987,
            "desc": "4987 - Longmont, CO"
        },
        {
            "code": 4989,
            "desc": "4989 - Auburn, AL"
        },
        {
            "code": 4990,
            "desc": "4990 - Daphne, AL"
        },
        {
            "code": 4991,
            "desc": "4991 - Cocoa, FL"
        },
        {
            "code": 4992,
            "desc": "4992 - Elizabethtown, KY"
        },
        {
            "code": 4993,
            "desc": "4993 - Lithia Springs, GA"
        },
        {
            "code": 4994,
            "desc": "4994 - Mechanicsburg, PA"
        },
        {
            "code": 4996,
            "desc": "4996 - Danville, VA"
        },
        {
            "code": 4998,
            "desc": "4998 - Lady Lake, FL"
        },
        {
            "code": 4999,
            "desc": "4999 - Quincy, IL"
        },
        {
            "code": 6181,
            "desc": "6181 - Papillion, NE"
        },
        {
            "code": 6188,
            "desc": "6188 - Austin, TX"
        },
        {
            "code": 6189,
            "desc": "6189 - Apopka, FL"
        },
        {
            "code": 6201,
            "desc": "6201 - Kingston, NY"
        },
        {
            "code": 6202,
            "desc": "6202 - Lufkin, TX"
        },
        {
            "code": 6203,
            "desc": "6203 - Columbia, SC"
        },
        {
            "code": 6204,
            "desc": "6204 - Valdosta, GA"
        },
        {
            "code": 6205,
            "desc": "6205 - Yuma, AZ"
        },
        {
            "code": 6212,
            "desc": "6212 - Orlando, FL"
        },
        {
            "code": 6213,
            "desc": "6213 - Chandler, AZ"
        },
        {
            "code": 6216,
            "desc": "6216 - Winterville, NC"
        },
        {
            "code": 6217,
            "desc": "6217 - Miami, FL"
        },
        {
            "code": 6218,
            "desc": "6218 - Orlando, FL"
        },
        {
            "code": 6219,
            "desc": "6219 - Colorado Springs, CO"
        },
        {
            "code": 6220,
            "desc": "6220 - Slidell, LA"
        },
        {
            "code": 6225,
            "desc": "6225 - Mayaguez, PR"
        },
        {
            "code": 6228,
            "desc": "6228 - Vernon Hills, IL"
        },
        {
            "code": 6235,
            "desc": "6235 - San Diego, CA"
        },
        {
            "code": 6236,
            "desc": "6236 - Rock Hill, SC"
        },
        {
            "code": 6238,
            "desc": "6238 - Owasso, OK"
        },
        {
            "code": 6239,
            "desc": "6239 - Timonium, MD"
        },
        {
            "code": 6240,
            "desc": "6240 - Glendora, CA"
        },
        {
            "code": 6242,
            "desc": "6242 - Dublin, OH"
        },
        {
            "code": 6244,
            "desc": "6244 - Fort Worth, TX"
        },
        {
            "code": 6245,
            "desc": "6245 - Harker Heights, TX"
        },
        {
            "code": 6246,
            "desc": "6246 - El Paso, TX"
        },
        {
            "code": 6247,
            "desc": "6247 - Kansas City, MO"
        },
        {
            "code": 6249,
            "desc": "6249 - Franklin, TN"
        },
        {
            "code": 6251,
            "desc": "6251 - Washington, PA"
        },
        {
            "code": 6252,
            "desc": "6252 - Chesterfield, MO"
        },
        {
            "code": 6253,
            "desc": "6253 - Tampa, FL"
        },
        {
            "code": 6254,
            "desc": "6254 - Maple Grove, MN"
        },
        {
            "code": 6255,
            "desc": "6255 - Plano, TX"
        },
        {
            "code": 6256,
            "desc": "6256 - Memphis, TN"
        },
        {
            "code": 6257,
            "desc": "6257 - Las Vegas, NV"
        },
        {
            "code": 6259,
            "desc": "6259 - Round Rock, TX"
        },
        {
            "code": 6260,
            "desc": "6260 - Bartlett, TN"
        },
        {
            "code": 6261,
            "desc": "6261 - Las Vegas, NV"
        },
        {
            "code": 6262,
            "desc": "6262 - San Antonio, TX"
        },
        {
            "code": 6265,
            "desc": "6265 - Irving, TX"
        },
        {
            "code": 6267,
            "desc": "6267 - Edmond, OK"
        },
        {
            "code": 6269,
            "desc": "6269 - Harlingen, TX"
        },
        {
            "code": 6270,
            "desc": "6270 - Hatillo, PR"
        },
        {
            "code": 6275,
            "desc": "6275 - Wichita, KS"
        },
        {
            "code": 6302,
            "desc": "6302 - Oakwood Village, OH"
        },
        {
            "code": 6304,
            "desc": "6304 - Indianapolis, IN"
        },
        {
            "code": 6305,
            "desc": "6305 - Brooklyn, OH"
        },
        {
            "code": 6307,
            "desc": "6307 - Columbus, OH"
        },
        {
            "code": 6308,
            "desc": "6308 - Columbus, OH"
        },
        {
            "code": 6309,
            "desc": "6309 - White Bear Lake, MN"
        },
        {
            "code": 6310,
            "desc": "6310 - Fridley, MN"
        },
        {
            "code": 6311,
            "desc": "6311 - Shakopee, MN"
        },
        {
            "code": 6312,
            "desc": "6312 - Woodbury, MN"
        },
        {
            "code": 6313,
            "desc": "6313 - Fort Wayne, IN"
        },
        {
            "code": 6314,
            "desc": "6314 - Sheffield Village, OH"
        },
        {
            "code": 6315,
            "desc": "6315 - Mishawaka, IN"
        },
        {
            "code": 6317,
            "desc": "6317 - Canton, OH"
        },
        {
            "code": 6319,
            "desc": "6319 - Kentwood, MI"
        },
        {
            "code": 6320,
            "desc": "6320 - Hermantown, MN"
        },
        {
            "code": 6321,
            "desc": "6321 - Appleton, WI"
        },
        {
            "code": 6322,
            "desc": "6322 - Boardman, OH"
        },
        {
            "code": 6324,
            "desc": "6324 - Milwaukee, WI"
        },
        {
            "code": 6325,
            "desc": "6325 - Greenwood, IN"
        },
        {
            "code": 6326,
            "desc": "6326 - Reynoldsburg, OH"
        },
        {
            "code": 6327,
            "desc": "6327 - Warren, OH"
        },
        {
            "code": 6328,
            "desc": "6328 - Cicero, IL"
        },
        {
            "code": 6329,
            "desc": "6329 - Tupelo, MS"
        },
        {
            "code": 6330,
            "desc": "6330 - Dover, DE"
        },
        {
            "code": 6331,
            "desc": "6331 - Kenosha, WI"
        },
        {
            "code": 6332,
            "desc": "6332 - Philadelphia, PA"
        },
        {
            "code": 6333,
            "desc": "6333 - Bangor, ME"
        },
        {
            "code": 6334,
            "desc": "6334 - Decatur, IL"
        },
        {
            "code": 6335,
            "desc": "6335 - Ocala, FL"
        },
        {
            "code": 6336,
            "desc": "6336 - Temple, TX"
        },
        {
            "code": 6338,
            "desc": "6338 - College Station, TX"
        },
        {
            "code": 6339,
            "desc": "6339 - Crystal Lake, IL"
        },
        {
            "code": 6341,
            "desc": "6341 - Sunrise, FL"
        },
        {
            "code": 6342,
            "desc": "6342 - Tulsa, OK"
        },
        {
            "code": 6343,
            "desc": "6343 - Richmond, VA"
        },
        {
            "code": 6344,
            "desc": "6344 - Des Moines, IA"
        },
        {
            "code": 6345,
            "desc": "6345 - Idaho Falls, ID"
        },
        {
            "code": 6347,
            "desc": "6347 - Farmington, NM"
        },
        {
            "code": 6348,
            "desc": "6348 - Pineville, NC"
        },
        {
            "code": 6349,
            "desc": "6349 - Evergreen Park, IL"
        },
        {
            "code": 6350,
            "desc": "6350 - Sherman, TX"
        },
        {
            "code": 6351,
            "desc": "6351 - Newport News, VA"
        },
        {
            "code": 6352,
            "desc": "6352 - Hudson, NH"
        },
        {
            "code": 6353,
            "desc": "6353 - Myrtle Beach, SC"
        },
        {
            "code": 6354,
            "desc": "6354 - Midlothian, VA"
        },
        {
            "code": 6355,
            "desc": "6355 - Hickory, NC"
        },
        {
            "code": 6356,
            "desc": "6356 - Fishkill, NY"
        },
        {
            "code": 6357,
            "desc": "6357 - Annapolis, MD"
        },
        {
            "code": 6358,
            "desc": "6358 - Northlake, IL"
        },
        {
            "code": 6359,
            "desc": "6359 - Comstock Park, MI"
        },
        {
            "code": 6360,
            "desc": "6360 - Grand Junction, CO"
        },
        {
            "code": 6361,
            "desc": "6361 - Fort Walton Beach, FL"
        },
        {
            "code": 6363,
            "desc": "6363 - Jacksonville, FL"
        },
        {
            "code": 6364,
            "desc": "6364 - Naples, FL"
        },
        {
            "code": 6365,
            "desc": "6365 - Charlottesville, VA"
        },
        {
            "code": 6366,
            "desc": "6366 - Vestal, NY"
        },
        {
            "code": 6367,
            "desc": "6367 - Humble, TX"
        },
        {
            "code": 6368,
            "desc": "6368 - Chesapeake, VA"
        },
        {
            "code": 6369,
            "desc": "6369 - Edison, NJ"
        },
        {
            "code": 6371,
            "desc": "6371 - Woodbridge, VA"
        },
        {
            "code": 6372,
            "desc": "6372 - Dallas, TX"
        },
        {
            "code": 6373,
            "desc": "6373 - Vienna, WV"
        },
        {
            "code": 6375,
            "desc": "6375 - Lima, OH"
        },
        {
            "code": 6376,
            "desc": "6376 - Dallas, TX"
        },
        {
            "code": 6377,
            "desc": "6377 - Jonesboro, AR"
        },
        {
            "code": 6378,
            "desc": "6378 - Riverside, CA"
        },
        {
            "code": 6379,
            "desc": "6379 - Great Falls, MT"
        },
        {
            "code": 6380,
            "desc": "6380 - Dayton, OH"
        },
        {
            "code": 6381,
            "desc": "6381 - Lewisville, TX"
        },
        {
            "code": 6382,
            "desc": "6382 - Las Vegas, NV"
        },
        {
            "code": 6383,
            "desc": "6383 - Salisbury, MD"
        },
        {
            "code": 6384,
            "desc": "6384 - Hodgkins, IL"
        },
        {
            "code": 6385,
            "desc": "6385 - Grand Forks, ND"
        },
        {
            "code": 6386,
            "desc": "6386 - Concord, NH"
        },
        {
            "code": 6387,
            "desc": "6387 - Pinellas Park, FL"
        },
        {
            "code": 6388,
            "desc": "6388 - Montgomery, IL"
        },
        {
            "code": 6401,
            "desc": "6401 - Tampa, FL"
        },
        {
            "code": 6402,
            "desc": "6402 - Greensboro, NC"
        },
        {
            "code": 6403,
            "desc": "6403 - Brandon, FL"
        },
        {
            "code": 6404,
            "desc": "6404 - Fairlawn, OH"
        },
        {
            "code": 6405,
            "desc": "6405 - Yuba City, CA"
        },
        {
            "code": 6406,
            "desc": "6406 - Niagara Falls, NY"
        },
        {
            "code": 6407,
            "desc": "6407 - Ontario, OH"
        },
        {
            "code": 6408,
            "desc": "6408 - Santa Fe, NM"
        },
        {
            "code": 6409,
            "desc": "6409 - Tucker, GA"
        },
        {
            "code": 6412,
            "desc": "6412 - Southgate, MI"
        },
        {
            "code": 6413,
            "desc": "6413 - Lincoln, NE"
        },
        {
            "code": 6414,
            "desc": "6414 - Gastonia, NC"
        },
        {
            "code": 6415,
            "desc": "6415 - Joplin, MO"
        },
        {
            "code": 6417,
            "desc": "6417 - Holland, MI"
        },
        {
            "code": 6418,
            "desc": "6418 - Wichita, KS"
        },
        {
            "code": 6419,
            "desc": "6419 - Traverse City, MI"
        },
        {
            "code": 6420,
            "desc": "6420 - Clearwater, FL"
        },
        {
            "code": 6421,
            "desc": "6421 - Conroe, TX"
        },
        {
            "code": 6422,
            "desc": "6422 - Longview, TX"
        },
        {
            "code": 6423,
            "desc": "6423 - Middletown, NY"
        },
        {
            "code": 6424,
            "desc": "6424 - Kokomo, IN"
        },
        {
            "code": 6425,
            "desc": "6425 - Casper, WY"
        },
        {
            "code": 6426,
            "desc": "6426 - Salina, KS"
        },
        {
            "code": 6427,
            "desc": "6427 - Rochester, MN"
        },
        {
            "code": 6428,
            "desc": "6428 - Medford, NY"
        },
        {
            "code": 6429,
            "desc": "6429 - Battle Creek, MI"
        },
        {
            "code": 6430,
            "desc": "6430 - Cheyenne, WY"
        },
        {
            "code": 6431,
            "desc": "6431 - Elmira, NY"
        },
        {
            "code": 6432,
            "desc": "6432 - Sioux City, IA"
        },
        {
            "code": 6433,
            "desc": "6433 - Vacaville, CA"
        },
        {
            "code": 6434,
            "desc": "6434 - Laurel, MD"
        },
        {
            "code": 6435,
            "desc": "6435 - Tuscaloosa, AL"
        },
        {
            "code": 6436,
            "desc": "6436 - Onalaska, WI"
        },
        {
            "code": 6437,
            "desc": "6437 - Bloomington, IN"
        },
        {
            "code": 6439,
            "desc": "6439 - Odessa, TX"
        },
        {
            "code": 6440,
            "desc": "6440 - Latham, NY"
        },
        {
            "code": 6441,
            "desc": "6441 - Lakeland, FL"
        },
        {
            "code": 6443,
            "desc": "6443 - Goldsboro, NC"
        },
        {
            "code": 6444,
            "desc": "6444 - Evanston, IL"
        },
        {
            "code": 6445,
            "desc": "6445 - Port Charlotte, FL"
        },
        {
            "code": 6448,
            "desc": "6448 - New Port Richey, FL"
        },
        {
            "code": 6449,
            "desc": "6449 - Paducah, KY"
        },
        {
            "code": 6450,
            "desc": "6450 - Cincinnati, OH"
        },
        {
            "code": 6452,
            "desc": "6452 - Asheville, NC"
        },
        {
            "code": 6453,
            "desc": "6453 - Austin, TX"
        },
        {
            "code": 6454,
            "desc": "6454 - Southfield, MI"
        },
        {
            "code": 6455,
            "desc": "6455 - Oxnard, CA"
        },
        {
            "code": 6456,
            "desc": "6456 - Plattsburgh, NY"
        },
        {
            "code": 6457,
            "desc": "6457 - South Charleston, WV"
        },
        {
            "code": 6458,
            "desc": "6458 - Lynchburg, VA"
        },
        {
            "code": 6460,
            "desc": "6460 - Altoona, PA"
        },
        {
            "code": 6461,
            "desc": "6461 - Grand Island, NE"
        },
        {
            "code": 6462,
            "desc": "6462 - Augusta, ME"
        },
        {
            "code": 6463,
            "desc": "6463 - Anderson, SC"
        },
        {
            "code": 6464,
            "desc": "6464 - Des Plaines, IL"
        },
        {
            "code": 6471,
            "desc": "6471 - Victoria, TX"
        },
        {
            "code": 6472,
            "desc": "6472 - Council Bluffs, IA"
        },
        {
            "code": 6474,
            "desc": "6474 - Maplewood, MO"
        },
        {
            "code": 6479,
            "desc": "6479 - Cape Girardeau, MO"
        },
        {
            "code": 6482,
            "desc": "6482 - Dallas, TX"
        },
        {
            "code": 6485,
            "desc": "6485 - Tinley Park, IL"
        },
        {
            "code": 6487,
            "desc": "6487 - Addison, IL"
        },
        {
            "code": 6489,
            "desc": "6489 - Calumet City, IL"
        },
        {
            "code": 6490,
            "desc": "6490 - Worcester, MA"
        },
        {
            "code": 6501,
            "desc": "6501 - Murfreesboro, TN"
        },
        {
            "code": 6502,
            "desc": "6502 - El Paso, TX"
        },
        {
            "code": 6503,
            "desc": "6503 - Hattiesburg, MS"
        },
        {
            "code": 6504,
            "desc": "6504 - Matteson, IL"
        },
        {
            "code": 6505,
            "desc": "6505 - Jefferson City, MO"
        },
        {
            "code": 6506,
            "desc": "6506 - Albany, GA"
        },
        {
            "code": 6507,
            "desc": "6507 - Jackson, TN"
        },
        {
            "code": 6509,
            "desc": "6509 - Rome, GA"
        },
        {
            "code": 6510,
            "desc": "6510 - Mankato, MN"
        },
        {
            "code": 6511,
            "desc": "6511 - Fort Worth, TX"
        },
        {
            "code": 6512,
            "desc": "6512 - Clarksville, TN"
        },
        {
            "code": 6514,
            "desc": "6514 - Waterloo, IA"
        },
        {
            "code": 6517,
            "desc": "6517 - Beavercreek, OH"
        },
        {
            "code": 6518,
            "desc": "6518 - Bristol, VA"
        },
        {
            "code": 6520,
            "desc": "6520 - Vero Beach, FL"
        },
        {
            "code": 6521,
            "desc": "6521 - Houma, LA"
        },
        {
            "code": 6522,
            "desc": "6522 - Gardena, CA"
        },
        {
            "code": 6524,
            "desc": "6524 - Colonial Heights, VA"
        },
        {
            "code": 6527,
            "desc": "6527 - Baton Rouge, LA"
        },
        {
            "code": 6528,
            "desc": "6528 - Cincinnati, OH"
        },
        {
            "code": 6533,
            "desc": "6533 - State College, PA"
        },
        {
            "code": 6535,
            "desc": "6535 - Wausau, WI"
        },
        {
            "code": 6536,
            "desc": "6536 - Allentown, PA"
        },
        {
            "code": 6539,
            "desc": "6539 - Watertown, NY"
        },
        {
            "code": 6540,
            "desc": "6540 - Charlotte, NC"
        },
        {
            "code": 6543,
            "desc": "6543 - Carolina, PR"
        },
        {
            "code": 6547,
            "desc": "6547 - Muncy, PA"
        },
        {
            "code": 6549,
            "desc": "6549 - Pueblo, CO"
        },
        {
            "code": 6556,
            "desc": "6556 - Saint Clairsville, OH"
        },
        {
            "code": 6562,
            "desc": "6562 - Muskegon, MI"
        },
        {
            "code": 6565,
            "desc": "6565 - Rapid City, SD"
        },
        {
            "code": 6567,
            "desc": "6567 - Easton, PA"
        },
        {
            "code": 6568,
            "desc": "6568 - Ames, IA"
        },
        {
            "code": 6569,
            "desc": "6569 - Bluefield, VA"
        },
        {
            "code": 6570,
            "desc": "6570 - Raleigh, NC"
        },
        {
            "code": 6571,
            "desc": "6571 - Florence, SC"
        },
        {
            "code": 6572,
            "desc": "6572 - Knoxville, TN"
        },
        {
            "code": 6573,
            "desc": "6573 - Jacksonville, NC"
        },
        {
            "code": 6575,
            "desc": "6575 - Pittsburgh, PA"
        },
        {
            "code": 6581,
            "desc": "6581 - Scranton Dickson City, PA"
        },
        {
            "code": 6582,
            "desc": "6582 - Bluffton, SC"
        },
        {
            "code": 6604,
            "desc": "6604 - Flagstaff, AZ"
        },
        {
            "code": 6605,
            "desc": "6605 - Gilbert, AZ"
        },
        {
            "code": 6606,
            "desc": "6606 - Phoenix, AZ"
        },
        {
            "code": 6608,
            "desc": "6608 - Phoenix, AZ"
        },
        {
            "code": 6609,
            "desc": "6609 - Palm Desert, CA"
        },
        {
            "code": 6610,
            "desc": "6610 - Chino, CA"
        },
        {
            "code": 6612,
            "desc": "6612 - Concord, CA"
        },
        {
            "code": 6613,
            "desc": "6613 - Long Beach, CA"
        },
        {
            "code": 6614,
            "desc": "6614 - El Monte, CA"
        },
        {
            "code": 6615,
            "desc": "6615 - Fountain Valley, CA"
        },
        {
            "code": 6616,
            "desc": "6616 - Fullerton, CA"
        },
        {
            "code": 6617,
            "desc": "6617 - Gardena, CA"
        },
        {
            "code": 6619,
            "desc": "6619 - Ontario, CA"
        },
        {
            "code": 6620,
            "desc": "6620 - Folsom, CA"
        },
        {
            "code": 6621,
            "desc": "6621 - Roseville, CA"
        },
        {
            "code": 6622,
            "desc": "6622 - Sacramento, CA"
        },
        {
            "code": 6624,
            "desc": "6624 - San Bernardino, CA"
        },
        {
            "code": 6626,
            "desc": "6626 - South Gate, CA"
        },
        {
            "code": 6628,
            "desc": "6628 - Torrance, CA"
        },
        {
            "code": 6630,
            "desc": "6630 - Arvada, CO"
        },
        {
            "code": 6631,
            "desc": "6631 - Aurora, CO"
        },
        {
            "code": 6632,
            "desc": "6632 - Denver, CO"
        },
        {
            "code": 6633,
            "desc": "6633 - Fort Collins, CO"
        },
        {
            "code": 6634,
            "desc": "6634 - Lone Tree, CO"
        },
        {
            "code": 6635,
            "desc": "6635 - Littleton, CO"
        },
        {
            "code": 6636,
            "desc": "6636 - Newington, CT"
        },
        {
            "code": 6637,
            "desc": "6637 - Coral Springs, FL"
        },
        {
            "code": 6643,
            "desc": "6643 - Atlanta, GA"
        },
        {
            "code": 6644,
            "desc": "6644 - Oakwood, GA"
        },
        {
            "code": 6646,
            "desc": "6646 - Alpharetta, GA"
        },
        {
            "code": 6650,
            "desc": "6650 - Baltimore, MD"
        },
        {
            "code": 6651,
            "desc": "6651 - Catonsville, MD"
        },
        {
            "code": 6652,
            "desc": "6652 - Frederick, MD"
        },
        {
            "code": 6653,
            "desc": "6653 - Gaithersburg, MD"
        },
        {
            "code": 6655,
            "desc": "6655 - Waldorf, MD"
        },
        {
            "code": 6657,
            "desc": "6657 - Novi, MI"
        },
        {
            "code": 6658,
            "desc": "6658 - Jackson, MI"
        },
        {
            "code": 6659,
            "desc": "6659 - Madison Heights, MI"
        },
        {
            "code": 6660,
            "desc": "6660 - Port Huron, MI"
        },
        {
            "code": 6661,
            "desc": "6661 - Portage, MI"
        },
        {
            "code": 6662,
            "desc": "6662 - Roseville, MI"
        },
        {
            "code": 6663,
            "desc": "6663 - Saginaw, MI"
        },
        {
            "code": 6664,
            "desc": "6664 - Utica, MI"
        },
        {
            "code": 6666,
            "desc": "6666 - Canton, MI"
        },
        {
            "code": 6667,
            "desc": "6667 - Ypsilanti, MI"
        },
        {
            "code": 6670,
            "desc": "6670 - Deptford, NJ"
        },
        {
            "code": 6671,
            "desc": "6671 - Freehold, NJ"
        },
        {
            "code": 6672,
            "desc": "6672 - Albuquerque, NM"
        },
        {
            "code": 6673,
            "desc": "6673 - Cheektowaga, NY"
        },
        {
            "code": 6674,
            "desc": "6674 - Elmsford, NY"
        },
        {
            "code": 6675,
            "desc": "6675 - Erie, PA"
        },
        {
            "code": 6676,
            "desc": "6676 - Willow Grove, PA"
        },
        {
            "code": 6677,
            "desc": "6677 - Monroeville, PA"
        },
        {
            "code": 6678,
            "desc": "6678 - Pittsburgh, PA"
        },
        {
            "code": 6679,
            "desc": "6679 - West Mifflin, PA"
        },
        {
            "code": 6680,
            "desc": "6680 - Bayamon, PR"
        },
        {
            "code": 6682,
            "desc": "6682 - Layton, UT"
        },
        {
            "code": 6683,
            "desc": "6683 - Murray, UT"
        },
        {
            "code": 6684,
            "desc": "6684 - Riverdale, UT"
        },
        {
            "code": 6685,
            "desc": "6685 - Provo, UT"
        },
        {
            "code": 6686,
            "desc": "6686 - Salt Lake City, UT"
        },
        {
            "code": 6689,
            "desc": "6689 - Caguas, PR"
        },
        {
            "code": 6690,
            "desc": "6690 - Ponce, PR"
        },
        {
            "code": 6692,
            "desc": "6692 - Tucson, AZ"
        },
        {
            "code": 6693,
            "desc": "6693 - Langhorne, PA"
        },
        {
            "code": 6779,
            "desc": "6779 - Moore, OK"
        },
        {
            "code": 6781,
            "desc": "6781 - Keller, TX"
        },
        {
            "code": 6845,
            "desc": "6845 - Fort Worth, TX"
        },
        {
            "code": 6867,
            "desc": "6867 - Richmond, TX"
        },
        {
            "code": 6976,
            "desc": "6976 - Wake Forest, NC"
        },
        {
            "code": 6979,
            "desc": "6979 - Ankeny, IA"
        },
        {
            "code": 7189,
            "desc": "7189 - Oklahoma City, OK"
        },
        {
            "code": 7191,
            "desc": "7191 - Miramar, FL"
        },
        {
            "code": 7658,
            "desc": "7658 - Brunswick, GA"
        },
        {
            "code": 7676,
            "desc": "7676 - Amarillo, TX"
        },
        {
            "code": 8101,
            "desc": "8101 - Lancaster, TX"
        },
        {
            "code": 8102,
            "desc": "8102 - Mobile, AL"
        },
        {
            "code": 8104,
            "desc": "8104 - Little Rock, AR"
        },
        {
            "code": 8106,
            "desc": "8106 - Montgomery, AL"
        },
        {
            "code": 8107,
            "desc": "8107 - Huntsville, AL"
        },
        {
            "code": 8111,
            "desc": "8111 - Jeffersontown, KY"
        },
        {
            "code": 8112,
            "desc": "8112 - Chattanooga, TN"
        },
        {
            "code": 8114,
            "desc": "8114 - Lafayette, LA"
        },
        {
            "code": 8115,
            "desc": "8115 - Augusta, GA"
        },
        {
            "code": 8116,
            "desc": "8116 - Jacksonville, FL"
        },
        {
            "code": 8117,
            "desc": "8117 - Oklahoma City, OK"
        },
        {
            "code": 8119,
            "desc": "8119 - Pensacola, FL"
        },
        {
            "code": 8120,
            "desc": "8120 - Tallahassee, FL"
        },
        {
            "code": 8123,
            "desc": "8123 - Evansville, IN"
        },
        {
            "code": 8125,
            "desc": "8125 - Saint Louis, MO"
        },
        {
            "code": 8126,
            "desc": "8126 - Brownsville, TX"
        },
        {
            "code": 8128,
            "desc": "8128 - Peoria, IL"
        },
        {
            "code": 8129,
            "desc": "8129 - Wilmington, NC"
        },
        {
            "code": 8130,
            "desc": "8130 - Fort Myers, FL"
        },
        {
            "code": 8132,
            "desc": "8132 - Springdale, OH"
        },
        {
            "code": 8133,
            "desc": "8133 - Florence, KY"
        },
        {
            "code": 8134,
            "desc": "8134 - Fort Smith, AR"
        },
        {
            "code": 8135,
            "desc": "8135 - Terre Haute, IN"
        },
        {
            "code": 8136,
            "desc": "8136 - Washington Township, OH"
        },
        {
            "code": 8138,
            "desc": "8138 - Daytona Beach, FL"
        },
        {
            "code": 8139,
            "desc": "8139 - Holland, OH"
        },
        {
            "code": 8141,
            "desc": "8141 - Melbourne, FL"
        },
        {
            "code": 8142,
            "desc": "8142 - Spartanburg, SC"
        },
        {
            "code": 8144,
            "desc": "8144 - Pleasantville, NJ"
        },
        {
            "code": 8145,
            "desc": "8145 - Cinnaminson, NJ"
        },
        {
            "code": 8146,
            "desc": "8146 - Omaha, NE"
        },
        {
            "code": 8147,
            "desc": "8147 - Loveland, CO"
        },
        {
            "code": 8149,
            "desc": "8149 - Green Bay, WI"
        },
        {
            "code": 8150,
            "desc": "8150 - Port St Lucie, FL"
        },
        {
            "code": 8151,
            "desc": "8151 - Panama City, FL"
        },
        {
            "code": 8152,
            "desc": "8152 - South Point, OH"
        },
        {
            "code": 8153,
            "desc": "8153 - El Paso, TX"
        },
        {
            "code": 8155,
            "desc": "8155 - Gainesville, FL"
        },
        {
            "code": 8156,
            "desc": "8156 - Laredo, TX"
        },
        {
            "code": 8157,
            "desc": "8157 - West Palm Beach, FL"
        },
        {
            "code": 8158,
            "desc": "8158 - Woodstock, GA"
        },
        {
            "code": 8160,
            "desc": "8160 - Temple, PA"
        },
        {
            "code": 8161,
            "desc": "8161 - York, PA"
        },
        {
            "code": 8162,
            "desc": "8162 - Cedar Rapids, IA"
        },
        {
            "code": 8163,
            "desc": "8163 - Columbia, MO"
        },
        {
            "code": 8164,
            "desc": "8164 - Waukesha, WI"
        },
        {
            "code": 8165,
            "desc": "8165 - Sioux Falls, SD"
        },
        {
            "code": 8166,
            "desc": "8166 - Duluth, GA"
        },
        {
            "code": 8167,
            "desc": "8167 - Franklin, WI"
        },
        {
            "code": 8168,
            "desc": "8168 - Indianapolis, IN"
        },
        {
            "code": 8169,
            "desc": "8169 - Lafayette, IN"
        },
        {
            "code": 8172,
            "desc": "8172 - Fargo, ND"
        },
        {
            "code": 8173,
            "desc": "8173 - Miramar, FL"
        },
        {
            "code": 8174,
            "desc": "8174 - Merrillville, IN"
        },
        {
            "code": 8175,
            "desc": "8175 - Harrisburg, PA"
        },
        {
            "code": 8176,
            "desc": "8176 - Topeka, KS"
        },
        {
            "code": 8177,
            "desc": "8177 - Las Vegas, NV"
        },
        {
            "code": 8180,
            "desc": "8180 - Marion, IL"
        },
        {
            "code": 8181,
            "desc": "8181 - Alexandria, LA"
        },
        {
            "code": 8182,
            "desc": "8182 - Saint Louis, MO"
        },
        {
            "code": 8183,
            "desc": "8183 - Saint Cloud, MN"
        },
        {
            "code": 8184,
            "desc": "8184 - Gurnee, IL"
        },
        {
            "code": 8185,
            "desc": "8185 - Eau Claire, WI"
        },
        {
            "code": 8186,
            "desc": "8186 - Scarborough, ME"
        },
        {
            "code": 8188,
            "desc": "8188 - Lexington, KY"
        },
        {
            "code": 8189,
            "desc": "8189 - Clarksburg, WV"
        },
        {
            "code": 8190,
            "desc": "8190 - La Marque, TX"
        },
        {
            "code": 8191,
            "desc": "8191 - Wilkes Barre, PA"
        },
        {
            "code": 8192,
            "desc": "8192 - Dothan, AL"
        },
        {
            "code": 8193,
            "desc": "8193 - Hagerstown, MD"
        },
        {
            "code": 8194,
            "desc": "8194 - Athens, GA"
        },
        {
            "code": 8196,
            "desc": "8196 - Florence, AL"
        },
        {
            "code": 8197,
            "desc": "8197 - Champaign, IL"
        },
        {
            "code": 8201,
            "desc": "8201 - Bradenton, FL"
        },
        {
            "code": 8202,
            "desc": "8202 - Savannah, GA"
        },
        {
            "code": 8203,
            "desc": "8203 - Marietta, GA"
        },
        {
            "code": 8205,
            "desc": "8205 - Saint Louis, MO"
        },
        {
            "code": 8207,
            "desc": "8207 - Kansas City, MO"
        },
        {
            "code": 8208,
            "desc": "8208 - Lenexa, KS"
        },
        {
            "code": 8209,
            "desc": "8209 - Fayetteville, AR"
        },
        {
            "code": 8210,
            "desc": "8210 - Burleson, TX"
        },
        {
            "code": 8211,
            "desc": "8211 - Douglasville, GA"
        },
        {
            "code": 8213,
            "desc": "8213 - Columbus, GA"
        },
        {
            "code": 8215,
            "desc": "8215 - Springfield, IL"
        },
        {
            "code": 8218,
            "desc": "8218 - Fayetteville, NC"
        },
        {
            "code": 8219,
            "desc": "8219 - Matthews, NC"
        },
        {
            "code": 8220,
            "desc": "8220 - Roanoke, VA"
        },
        {
            "code": 8221,
            "desc": "8221 - Harvey, LA"
        },
        {
            "code": 8222,
            "desc": "8222 - Johnson City, TN"
        },
        {
            "code": 8223,
            "desc": "8223 - Raleigh, NC"
        },
        {
            "code": 8224,
            "desc": "8224 - Wichita Falls, TX"
        },
        {
            "code": 8225,
            "desc": "8225 - Macon, GA"
        },
        {
            "code": 8226,
            "desc": "8226 - Abilene, TX"
        },
        {
            "code": 8227,
            "desc": "8227 - San Antonio, TX"
        },
        {
            "code": 8228,
            "desc": "8228 - Winston Salem, NC"
        },
        {
            "code": 8236,
            "desc": "8236 - Gulfport, MS"
        },
        {
            "code": 8237,
            "desc": "8237 - Monroe, LA"
        },
        {
            "code": 8238,
            "desc": "8238 - Davenport, IA"
        },
        {
            "code": 8239,
            "desc": "8239 - Lawton, OK"
        },
        {
            "code": 8241,
            "desc": "8241 - Midwest City, OK"
        },
        {
            "code": 8242,
            "desc": "8242 - Dallas, TX"
        },
        {
            "code": 8243,
            "desc": "8243 - Raymore, MO"
        },
        {
            "code": 8244,
            "desc": "8244 - Houston, TX"
        },
        {
            "code": 8245,
            "desc": "8245 - Houston, TX"
        },
        {
            "code": 8246,
            "desc": "8246 - Stafford Meadows, TX"
        },
        {
            "code": 8247,
            "desc": "8247 - Homewood, AL"
        },
        {
            "code": 8248,
            "desc": "8248 - Dallas, TX"
        },
        {
            "code": 8250,
            "desc": "8250 - Mcallen, TX"
        },
        {
            "code": 8251,
            "desc": "8251 - Saint Charles, MO"
        },
        {
            "code": 8252,
            "desc": "8252 - North Charleston, SC"
        },
        {
            "code": 8253,
            "desc": "8253 - Jacksonville, FL"
        },
        {
            "code": 8254,
            "desc": "8254 - Wichita, KS"
        },
        {
            "code": 8256,
            "desc": "8256 - Knoxville, TN"
        },
        {
            "code": 8257,
            "desc": "8257 - Hendersonville, TN"
        },
        {
            "code": 8259,
            "desc": "8259 - Austin, TX"
        },
        {
            "code": 8261,
            "desc": "8261 - Kenner, LA"
        },
        {
            "code": 8262,
            "desc": "8262 - San Antonio, TX"
        },
        {
            "code": 8263,
            "desc": "8263 - Tulsa, OK"
        },
        {
            "code": 8264,
            "desc": "8264 - San Antonio, TX"
        },
        {
            "code": 8265,
            "desc": "8265 - Lake Charles, LA"
        },
        {
            "code": 8266,
            "desc": "8266 - North Little Rock, AR"
        },
        {
            "code": 8267,
            "desc": "8267 - Corpus Christi, TX"
        },
        {
            "code": 8268,
            "desc": "8268 - North Richland Hills, TX"
        },
        {
            "code": 8269,
            "desc": "8269 - Grand Prairie, TX"
        },
        {
            "code": 8270,
            "desc": "8270 - Lubbock, TX"
        },
        {
            "code": 8271,
            "desc": "8271 - Madison, MS"
        },
        {
            "code": 8272,
            "desc": "8272 - Colorado Springs, CO"
        },
        {
            "code": 8273,
            "desc": "8273 - Shreveport, LA"
        },
        {
            "code": 8274,
            "desc": "8274 - Houston, TX"
        },
        {
            "code": 8275,
            "desc": "8275 - Beaumont, TX"
        },
        {
            "code": 8276,
            "desc": "8276 - Louisville, KY"
        },
        {
            "code": 8277,
            "desc": "8277 - Westworth Village, TX"
        },
        {
            "code": 8278,
            "desc": "8278 - Greenville, SC"
        },
        {
            "code": 8279,
            "desc": "8279 - Amarillo, TX"
        },
        {
            "code": 8280,
            "desc": "8280 - El Paso, TX"
        },
        {
            "code": 8281,
            "desc": "8281 - Houston, TX"
        },
        {
            "code": 8282,
            "desc": "8282 - Dallas, TX"
        },
        {
            "code": 8283,
            "desc": "8283 - Columbia, SC"
        },
        {
            "code": 8284,
            "desc": "8284 - Tyler, TX"
        },
        {
            "code": 8285,
            "desc": "8285 - O Fallon, IL"
        },
        {
            "code": 8286,
            "desc": "8286 - Waco, TX"
        },
        {
            "code": 8287,
            "desc": "8287 - Morrow, GA"
        },
        {
            "code": 8288,
            "desc": "8288 - Midland, TX"
        },
        {
            "code": 8289,
            "desc": "8289 - Oklahoma City, OK"
        },
        {
            "code": 8290,
            "desc": "8290 - Orlando, FL"
        },
        {
            "code": 8291,
            "desc": "8291 - Flint, MI"
        },
        {
            "code": 8292,
            "desc": "8292 - Memphis, TN"
        },
        {
            "code": 8293,
            "desc": "8293 - Independence, MO"
        },
        {
            "code": 8294,
            "desc": "8294 - Nashville, TN"
        },
        {
            "code": 8295,
            "desc": "8295 - Texarkana, TX"
        },
        {
            "code": 8296,
            "desc": "8296 - Springfield, MO"
        },
        {
            "code": 8297,
            "desc": "8297 - Rockford, IL"
        },
        {
            "code": 8298,
            "desc": "8298 - Joliet, IL"
        },
        {
            "code": 8299,
            "desc": "8299 - Plano, TX"
        },
        {
            "code": 8799,
            "desc": "8799 - Perris, CA"
        },
        {
            "code": 9475,
            "desc": "9475 - Groveport, OH"
        },
        {
            "code": 9476,
            "desc": "9476 - Perris, CA"
        },
        {
            "code": 9639,
            "desc": "9639 - Lumberton, NC"
        }
    ],
    "clubTypes": [
        {
            "code": "F",
            "desc": "Fulfillment Center"
        },
        {
            "code": "C",
            "desc": "Club"
        }
    ],
    "carriers": [
        {
            "code": "AQSM",
            "desc": "AQSM"
        },
        {
            "code": "AWLO",
            "desc": "AWLO"
        },
        {
            "code": "CRAM",
            "desc": "CRAM"
        },
        {
            "code": "HLBO",
            "desc": "HLBO"
        },
        {
            "code": "KAEJ",
            "desc": "KAEJ"
        },
        {
            "code": "KNIG",
            "desc": "KNIG"
        },
        {
            "code": "LGSB",
            "desc": "LGSB"
        },
        {
            "code": "PAMT",
            "desc": "PAMT"
        },
        {
            "code": "PASC",
            "desc": "PASC"
        },
        {
            "code": "PLCY",
            "desc": "PLCY"
        },
        {
            "code": "POQC",
            "desc": "POQC"
        },
        {
            "code": "PPRK",
            "desc": "PPRK"
        },
        {
            "code": "SDCK",
            "desc": "SDCK"
        },
        {
            "code": "SEBG",
            "desc": "SEBG"
        },
        {
            "code": "SWFT",
            "desc": "SWFT"
        },
        {
            "code": "TTMS",
            "desc": "TTMS"
        },
        {
            "code": "USXI",
            "desc": "USXI"
        },
        {
            "code": "WENI",
            "desc": "WENI"
        },
        {
            "code": "WERE",
            "desc": "WERE"
        },
        {
            "code": "WM",
            "desc": "WM"
        },
        {
            "code": "WMT",
            "desc": "WMT"
        }
    ],
    "carrierTypes": [
        {
            "code": 1,
            "desc": "WM Fleet"
        },
        {
            "code": 2,
            "desc": "Third Party"
        }
    ],
    "loadStatus": [
        {
            "code": 1,
            "desc": "On time"
        },
        {
            "code": 8,
            "desc": "Billed/invoiced"
        },
        {
            "code": 2,
            "desc": "At risk"
        },
        {
            "code": 3,
            "desc": "Delayed"
        },
        {
            "code": 4,
            "desc": "In transit"
        },
        {
            "code": 7,
            "desc": "Delivery pending"
        },
        {
            "code": 5,
            "desc": "Delivered"
        },
        {
            "code": 6,
            "desc": "Received"
        }
    ],
    "loadDwells": [
        {
            "code": 1,
            "desc": "0-24 hours"
        },
        {
            "code": 2,
            "desc": "24-48 hours"
        },
        {
            "code": 3,
            "desc": "greater than 48 hours"
        }
    ],
    "events": [
        {
            "code": 29,
            "desc": "FY26 March ISB"
        }
    ],
    "outOfStock": [
        {
            "code": 1,
            "desc": "Yes"
        },
        {
            "code": 0,
            "desc": "No"
        }
    ]
}

export default filters